var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function find(array, predicate) {
  if (!Array.isArray(array)) {
    return;
  }
  if (Array.prototype.find) {
    return array.find(predicate);
  }
  var result;
  array.some(function(item) {
    if (predicate(item)) {
      result = item;
      return true;
    }
    return false;
  });
  return result;
}
__name(find, "find");
export {
  find
};
